module.exports = __webpack_public_path__ + "img/payza.19638943.svg";